import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import { CultureCustomsCard, RecentFavoritesListItem } from '../components';

const SidebarAccordion = ({ data, defaultOpen }) => {

    const { items, sectionDetails } = data;

    return (
        <Accordion
            type="single"
            collapsible
            defaultValue={defaultOpen ? "item-1" : undefined}
            className=""
        >
            <AccordionItem value="item-1" className="">
                <AccordionTrigger className="text-base font-bold text-gray-900 leading-5 [&>svg]:ml-3">
                    {sectionDetails.title}
                </AccordionTrigger>
                <AccordionContent className="mt-4 bg-gray-0 rounded-xl">
                    {items.map((item, index) => (
                         <div key={index} className="flex flex-col p-4 border-b border-gray-100 last:border-b-0">
                         <p className="font-medium text-sm leading-4.5 text-gray-900">
                           {item.title}
                         </p>
                         {item.categories && (
                           <span className="px-2 py-1 text-xs font-medium mt-3 rounded-[27px] bg-gold-50 text-gold-500 inline-block w-max">
                             {item.categories}
                           </span>
                         )}
                       </div>
                    ))}
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};

export default SidebarAccordion;